import { LOCALES } from 'Constants/General';

const useDateFormatter = t2 => {
  const formatExpirationDate = date => {
    if (!date) return null;

    const expirationDate = new Date(date);
    const dayNum = expirationDate.getDate();
    const month = expirationDate.toLocaleDateString(LOCALES, {
      month: 'long',
    });
    const year = expirationDate.getFullYear();

    return `${t2('ValidUntil')} ${dayNum} ${t2('Of')} ${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`;
  };

  return { formatExpirationDate };
};

export default useDateFormatter;
